const openLink = (url: string): void => {
  window.open(url, "", "noopener,noreferrer");
};

export default openLink;
